import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/bg.png'
import _imports_1 from '../assets/images/map_sc.png'
import _imports_2 from '../assets/images/point.png'
import _imports_3 from '../assets/images/point.gif'
import _imports_4 from '../assets/images/animate/dice-0.gif'


const _withScopeId = n => (_pushScopeId("data-v-973b2a70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-cont" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = { class: "cell-list" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "material",
  src: _imports_1
}, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "point",
  src: _imports_2
}
const _hoisted_7 = {
  key: 1,
  class: "point",
  src: _imports_3
}
const _hoisted_8 = {
  key: 0,
  class: "dice-animation"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 0,
  src: _imports_4
}

import { onMounted, ref, nextTick, watch } from 'vue';
import { MapCellState } from "../interface/index"
import dice01 from "../assets/images/animate/dice-1.png";
import dice02 from "../assets/images/animate/dice-2.png";
import dice03 from "../assets/images/animate/dice-3.png";
import dice04 from "../assets/images/animate/dice-4.png";
import dice05 from "../assets/images/animate/dice-5.png";
import dice06 from "../assets/images/animate/dice-6.png";
import { showLoadingToast } from 'vant';
import { FindAllCellApi } from '@/api';
const designWidth = 750;


export default /*#__PURE__*/_defineComponent({
  __name: 'MapView',
  props: {
  cellIndex: {
    type: Number,
    default: 0
  }
},
  setup(__props, { expose: __expose }) {

const props = __props;

const scalc = ref(1);
const width = ref(750);
const height = ref(813);
const position = ref({ x: 0, y: 0 });
const latticeList = ref<Array<MapCellState>>([]);
const mapDrawDown = ref(false);
const isPointMoveIng = ref(false);
const indicatorIndex = ref(0);
const playDiceAnimation = ref(false);//播放骰子动画
const diceNum = ref(0);

onMounted(() => {
  width.value = window.innerWidth;
  scalc.value = designWidth / width.value;
  height.value = width.value / (750 / 813);
  findAllCellList();
});

// indicatorIndex.value = props.cellIndex
// console.log(props.cellIndex)
//获取所有格子
const findAllCellList = () => {
  const toast = showLoadingToast({ message: "加载中...", loadingType: 'spinner', duration: 0, overlay: true })
  FindAllCellApi({}).then((res: any) => {
    toast.close();
    let list = res.resultObj || [];
    let newList = list.map((item: any) => {
      return {
        imageTemp: '', x: item.xcoordinate / scalc.value, y: item.ycoordinate / scalc.value, imageUrl: item.cellBackground,
        cellType: item.cellType, id: item.id
      }
    });
    drawTaskCell(newList)
  }).catch(() => toast.close())
}
//绘制任务格子
const drawTaskCell = (cellList: Array<MapCellState>) => {
  let promiseList: Array<Promise<unknown>> = [];
  //格子素材
  cellList.forEach((item: MapCellState) => {
    let pm = downloadMaterial(item, item.imageUrl)
    promiseList.push(pm);
  })
  Promise.all(promiseList).then(() => {
    latticeList.value = cellList;
    changeIndicatorPosition(props.cellIndex);
    indicatorIndex.value = props.cellIndex
    mapDrawDown.value = true;
  });
}

//开始摇骰子
const dicePlayingBegin = () => {
  playDiceAnimation.value = true;
  isPointMoveIng.value = false;
}
//结束摇骰子
const dicePlayingEnd = (duration: number, num: number) => {
  if (!duration) return playDiceAnimation.value = false;
  setTimeout(() => {
    diceNum.value = num;
    setTimeout(() => {
      //摇骰子结束
      diceNum.value = 0;
      playDiceAnimation.value = false;
    }, 2000)
    setTimeout(() => {
      nextTick(() => {
        //移动指示器
        mapPointMove(num, 612)
      })
    }, 2000)

  }, duration - 0)
}

//坐标点移动
const mapPointMove = (num: number, timer: number) => {
  indicatorIndex.value++;
  if (indicatorIndex.value >= 29) {
    indicatorIndex.value = 0;
  }
  isPointMoveIng.value = true;
  changeIndicatorPosition(indicatorIndex.value)
  num--;
  if (num > 0) {
    setTimeout(() => {
      isPointMoveIng.value = false;
    }, timer - 100)
    setTimeout(() => {
      mapPointMove(num, timer);
    }, timer)
  } else {
    //最后移动格子
    setTimeout(() => {
      nextTick(() => {
        isPointMoveIng.value = false;
      })
    }, 500)
  }
}

//修改指示器坐标
const changeIndicatorPosition = (i: number) => {
  let item: any = latticeList.value[i];
  let { x, y, width, height } = item;
  let w = 80 / scalc.value;
  let h = 88 / scalc.value;
  let _x = (x + (width - w) / 2);
  let _y = (y - (h - height) / 2 - 50 / scalc.value);
  position.value = { x: _x, y: _y };
}

//下载图片
const downloadMaterial = (item: MapCellState, url: string) => {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.setAttribute("crossOrigin", "anonymous");
    img.src = url;
    img.onload = () => {
      item.width = img.width / scalc.value;
      item.height = img.height / scalc.value;
      resolve(img);
    }
    img.onerror = () => {
      reject();
    }
  })
}

__expose({
  dicePlayingBegin, dicePlayingEnd, mapPointMove
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(latticeList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "cell-item",
          key: index,
          style: _normalizeStyle(`left:${item.x}px;top:${item.y}px;`)
        }, [
          _createElementVNode("img", {
            src: item.imageUrl,
            style: _normalizeStyle(`width:${item.width}px;`)
          }, null, 12, _hoisted_4)
        ], 4))
      }), 128))
    ]),
    _hoisted_5,
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["indicator", { 'animate': isPointMoveIng.value }]),
      style: _normalizeStyle(`left:${position.value.x}px;top:${position.value.y}px;`)
    }, [
      (isPointMoveIng.value)
        ? (_openBlock(), _createElementBlock("img", _hoisted_6))
        : (_openBlock(), _createElementBlock("img", _hoisted_7))
    ], 6), [
      [_vShow, mapDrawDown.value]
    ]),
    (playDiceAnimation.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _withDirectives(_createElementVNode("img", {
            src: _unref(dice01) + '?t=' + +new Date()
          }, null, 8, _hoisted_9), [
            [_vShow, diceNum.value === 1]
          ]),
          _withDirectives(_createElementVNode("img", {
            src: _unref(dice02) + '?t=' + +new Date()
          }, null, 8, _hoisted_10), [
            [_vShow, diceNum.value === 2]
          ]),
          _withDirectives(_createElementVNode("img", {
            src: _unref(dice03) + '?t=' + +new Date()
          }, null, 8, _hoisted_11), [
            [_vShow, diceNum.value === 3]
          ]),
          _withDirectives(_createElementVNode("img", {
            src: _unref(dice04) + '?t=' + +new Date()
          }, null, 8, _hoisted_12), [
            [_vShow, diceNum.value === 4]
          ]),
          _withDirectives(_createElementVNode("img", {
            src: _unref(dice05) + '?t=' + +new Date()
          }, null, 8, _hoisted_13), [
            [_vShow, diceNum.value === 5]
          ]),
          _withDirectives(_createElementVNode("img", {
            src: _unref(dice06) + '?t=' + +new Date()
          }, null, 8, _hoisted_14), [
            [_vShow, diceNum.value === 6]
          ]),
          (diceNum.value === 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_15))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})